/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DivisionInputs */

const th_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดิวิชั่น`)
};

const en_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Division`)
};

const ja_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ディビジョン`)
};

const zh_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分区`)
};

const es_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría`)
};

const pt_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const id_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisi`)
};

const fr_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie`)
};

const tl_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibisyon`)
};

const vi_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng`)
};

const ko_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디비전`)
};

const de_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasse`)
};

const ru_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дивизион`)
};

const tr_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grup`)
};

const it_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const pl_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupa`)
};

const uk_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дивізіон`)
};

const hi_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्ग`)
};

const ar_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئة`)
};

const ms_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisyen`)
};

const bn_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিভাগ`)
};

const zh_tw2_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分組`)
};

const zh_hk2_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組別`)
};

const ur_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درجہ`)
};

const fa_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`گروه`)
};

const sw_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daraja`)
};

const nl_division = /** @type {(inputs: DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasse`)
};

/**
* | output |
* | --- |
* | "Division" |
*
* @param {DivisionInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const division = /** @type {((inputs?: DivisionInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DivisionInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_division(inputs)
	if (locale === "ja") return ja_division(inputs)
	if (locale === "zh") return zh_division(inputs)
	if (locale === "es") return es_division(inputs)
	if (locale === "pt") return pt_division(inputs)
	if (locale === "id") return id_division(inputs)
	if (locale === "fr") return fr_division(inputs)
	if (locale === "tl") return tl_division(inputs)
	if (locale === "vi") return vi_division(inputs)
	if (locale === "ko") return ko_division(inputs)
	if (locale === "de") return de_division(inputs)
	if (locale === "ru") return ru_division(inputs)
	if (locale === "tr") return tr_division(inputs)
	if (locale === "it") return it_division(inputs)
	if (locale === "pl") return pl_division(inputs)
	if (locale === "uk") return uk_division(inputs)
	if (locale === "hi") return hi_division(inputs)
	if (locale === "ar") return ar_division(inputs)
	if (locale === "ms") return ms_division(inputs)
	if (locale === "bn") return bn_division(inputs)
	if (locale === "zh-TW") return zh_tw2_division(inputs)
	if (locale === "zh-HK") return zh_hk2_division(inputs)
	if (locale === "ur") return ur_division(inputs)
	if (locale === "fa") return fa_division(inputs)
	if (locale === "sw") return sw_division(inputs)
	if (locale === "nl") return nl_division(inputs)
	return en_division(inputs)
});